import {mainQuery} from '@github-ui/react-core/future/main-query'
import {appShellAppBuilder} from '../config/app-builder'
import type {GlobalNavBarProps} from '@github-ui/global-navigation/bar'

export type AppShellLayoutResponse = {
  globalNavigation: GlobalNavBarProps
  someField: string
}

export const appShellLayoutRoute = appShellAppBuilder.createQueryRouteConfig('appShellLayoutRoute', {
  path: '/',
  queries: [
    mainQuery<AppShellLayoutResponse>({
      queryDeps: () => ({pathname: '/_shell/layout'}),
    }),
  ],
})
